import { BaseError } from '@/util/base-error'

export class MailMagazineLoadError extends BaseError {
  constructor(
    message: string,
    readonly label: string
  ) {
    super(message)
  }
}
